import ActionsModal from './ActionsModal';

export default ActionsModal;
